import * as PIXI from "pixi.js";
import { BASE_PATH, LOGO_PATH } from "../types/Config";


export default class TextureManager {
  private static basePath = BASE_PATH;
  private static logoPath: string = `${this.basePath}${LOGO_PATH}`;
  private static assetList: string[];
  private static textures: Record<string, PIXI.Texture>;
  private static logo: Record<string, PIXI.Texture>;

  constructor() { }

  static getLogo = () => new PIXI.Texture(this.logo);

  static async load(assetsList: string[], cb: (p: number) => void): Promise<void> {
    this.assetList = [...assetsList.map(asset => `${this.basePath}${asset}`)];
    this.textures = await PIXI.Assets.load(this.assetList, (p: number) => cb(Math.floor(p * 100)));
  }
  static async loadLogo(): Promise<void> {
    this.logo = await PIXI.Assets.load(this.logoPath);
  }
  static getTexture(_path: string): PIXI.Texture {
    const path = `${this.basePath}${_path}`;
    let Texture = this.textures[path];
    if (!Texture) {
      console.log("Texture is not found", path);
      Texture = PIXI.Texture.WHITE;
    }
    return new PIXI.Texture(Texture);
  }
}